import { LotsManagementList } from "../../../../../../core";
import { DataTable } from "../../../data-table.interface";
import { lotStates } from "../../../../../../core/configs/lots.config";

const iconsOfActionsList = [
  {
    icon: "picker",
    tooltip: "Asignar pedido",
    hasVisibleCondition: (element: any[]) => {
      return true;
    }
  },
];
const conditionAssign = (item: LotsManagementList) => {
  switch (item.state) {
    case lotStates.PENDING_PICKING:
    case lotStates.CREATED:
      return false;
    default:
      return true;
  }
};
export const lotsList: DataTable = {
  searchText: "",
  addText: "Nuevo lote",
  export: false,
  filter: false,
  checkbox: true,
  disabled: false,
  paginator: true,
  partialField: "",
  iconsOfActions: iconsOfActionsList,
  hasDisabledCheckBoxItem: (row: LotsManagementList) => {
    return conditionAssign(row)
},
  columns: [
    {
      title: "Zona",
      name: "zoneName",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: LotsManagementList) => element.zoneName,
    },
    { 
      title: "Nº Lote",
      name: "pickingLotNumber",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: LotsManagementList) => element.pickingLotNumber,
    },
    {
      title: "Fecha despacho",
      name: "dispatchDate",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: LotsManagementList) => element.dispatchDate,
    },
    {
      title: "Ventana horaria",
      name: "hourDeliveryWindow",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: LotsManagementList) =>
        element.startHourDeliveryWindow + " - " + element.endHourDeliveryWindow,
    },
    {
      title: "Cantidad",
      name: "amount",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: LotsManagementList) => element.amount,
    },
    {
      title: "Estado",
      name: "state",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: LotsManagementList) => element.state,
    },
    {
      title: "Fill Rate",
      name: "fillRate",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: LotsManagementList) => element.fillRate,
    },
    {
      title: "Nº máximo de despachos",
      name: "amountConsolidate",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: LotsManagementList) => element.clientsZone,
    },
    {
      title: "Picker",
      name: "picker",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: LotsManagementList) =>
        element.picker && element.picker != "null" ? element.picker : "",
    },
    {
      title: "Fecha de creación de lote",
      name: "lotCreationDate",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: LotsManagementList) => element.lotCreationDate,
    }
  ],
};
